<form autocomplete="off" class="p-0" novalidate [formGroup]="reservationsDetailsForm">
    <div class="col-lg-12 col-md-12">
        <div class="mt-3">
            <div class="mb-2">
                <h3 class="main-content-label mb-2"><b>
                        <img alt="Logo" width="20vh" src="../../assets/images/business-card.png"
                            class="mh-45px mrl mt-1 pb-2">
                        Reservations Details</b></h3>
            </div>
            <div *ngIf="ReservationShow" class="row clearfix">
                <div class="col-sm-2" *ngIf="reservationsDetailsFormArray['StuConstiCate'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{reservationsDetailsFormArray['StuConstiCate'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="reservationsDetailsFormArray['StuConstiCate'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select #select21 class="colorblack" formControlName="StuConstiCate">
                                    <mat-select-filter *ngIf="select21.focused" [placeholder]="'Filter'"
                                        [displayMember]="'CdDesc'" [array]="religionList"
                                        (filteredReturn)="filteredReligionList =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredReligionList" [value]="item.CdCode">
                                        {{item.CdDesc}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="reservationsDetailsForm.controls['StuConstiCate'].touched && reservationsDetailsForm.controls['StuConstiCate'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="reservationsDetailsFormArray['StuConstiSubCate'][0]['FormVisible']">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{reservationsDetailsFormArray['StuConstiSubCate'][0]['FormDisplayName']}}
                                <span
                                    *ngIf="reservationsDetailsFormArray['StuConstiSubCate'][0]['FormRequired']">*</span>
                            </mat-label>
                            <mat-select #select53 class="colorblack" formControlName="StuConstiSubCate">
                                <mat-select-filter *ngIf="select53.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CdDesc'" [array]="ConstiCateList"
                                    (filteredReturn)="filteredConstiCateList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredConstiCateList" [value]="item.CdCode"
                                    (click)="fetchCast2(item.CdCode)">
                                    {{item.CdDesc}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="reservationsDetailsForm.controls['StuConstiSubCate'].touched && reservationsDetailsForm.controls['StuConstiSubCate'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <!-- <div class="col-sm-2"></div> -->
                <div class="col-sm-2" *ngIf="reservationsDetailsFormArray['StuCaste'][0]['FormVisible']">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{reservationsDetailsFormArray['StuCaste'][0]['FormDisplayName']}}
                                <span *ngIf="reservationsDetailsFormArray['StuCaste'][0]['FormRequired']">*</span>
                            </mat-label>
                            <mat-select #select22 class="colorblack" formControlName="StuCaste" [disabled]="isStuCasteDisable">
                                <mat-select-filter *ngIf="select22.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CasteName'" [array]="categoryList"
                                    (filteredReturn)="filteredCategoryList =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredCategoryList" [value]="item.CasteId">
                                    {{item.CasteName}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="reservationsDetailsForm.controls['StuCaste'].touched && reservationsDetailsForm.controls['StuCaste'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="reservationsDetailsFormArray['StuCasteCert'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{reservationsDetailsFormArray['StuCasteCert'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="reservationsDetailsFormArray['StuCasteCert'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select [disabled]="isStuCasteCertDisable" formControlName="StuCasteCert" #select104 placeholder="Caste"
                                    class="colorblack">
                                    <mat-option>Select</mat-option>
                                    <mat-option [value]="1" (click)="onSelectionCastCertificat('1')">Yes</mat-option>
                                    <mat-option [value]="2" (click)="onSelectionCastCertificat('2')">No</mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="reservationsDetailsForm.controls['StuCasteCert'].touched && reservationsDetailsForm.controls['StuCasteCert'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="reservationsDetailsFormArray['StuCasteValCert'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{reservationsDetailsFormArray['StuCasteValCert'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="reservationsDetailsFormArray['StuCasteValCert'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select [disabled]="isStuCasteValCertDisable" formControlName="StuCasteValCert"
                                    #select104 placeholder="Validity" class="colorblack">
                                    <mat-option>Select</mat-option>
                                    <mat-option [value]="1">Yes</mat-option>
                                    <mat-option [value]="2">No</mat-option>
                                    <mat-option [value]="3">NA</mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="reservationsDetailsForm.controls['StuCasteValCert'].touched && reservationsDetailsForm.controls['StuCasteValCert'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="reservationsDetailsFormArray['StuNonCrmCert'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{reservationsDetailsFormArray['StuNonCrmCert'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="reservationsDetailsFormArray['StuNonCrmCert'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select [disabled]="isStuNonCrmCertDisable || isStuNonCrmValDtDisable2" formControlName="StuNonCrmCert" matTooltip="Non-creamy Layer Certificate"
                                    #select104 placeholder="Certificate" class="colorblack">
                                    <mat-option>Select</mat-option>
                                    <mat-option [value]="1" (click)="StuNonCrmValDtDisable('1')">Yes</mat-option>
                                    <mat-option [value]="2" (click)="StuNonCrmValDtDisable('2')">No</mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="reservationsDetailsForm.controls['StuNonCrmCert'].touched && reservationsDetailsForm.controls['StuNonCrmCert'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="reservationsDetailsFormArray['StuNonCrmValDt'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{reservationsDetailsFormArray['StuNonCrmValDt'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="reservationsDetailsFormArray['StuNonCrmValDt'][0]['FormRequired']">*</span>
                                </mat-label>
                                <!-- [readonly]="isStuNonCrmValDtDisable"  -->
                                <input [min]="currentdate" formControlName="StuNonCrmValDt"
                                    matTooltip="Non-creamy Layer Validity Date" matInput [matDatepicker]="dob" id="dob"
                                    placeholder="DD/MM/YYYY" [disabled]="isStuNonCrmValDtDisable">
                                <mat-datepicker-toggle matSuffix [for]="dob">
                                </mat-datepicker-toggle>
                                <mat-datepicker #dob [disabled]="isStuNonCrmValDtDisable"></mat-datepicker>
                                <mat-error class="margin_tp"
                                    *ngIf="reservationsDetailsForm.controls['StuNonCrmValDt'].touched && reservationsDetailsForm.controls['StuNonCrmValDt'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="reservationsDetailsFormArray['StuInHouse'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{reservationsDetailsFormArray['StuInHouse'][0]['FormDisplayName']}}
                                    <span *ngIf="reservationsDetailsFormArray['StuInHouse'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select [disabled]="isStuInHouseDisable" formControlName="StuInHouse"
                                    matTooltip="Are You Applying For In House Quota? " #select104 class="colorblack">
                                    <mat-option>Select</mat-option>
                                    <mat-option [value]="1">Yes</mat-option>
                                    <mat-option [value]="2">No</mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="reservationsDetailsForm.controls['StuInHouse'].touched && reservationsDetailsForm.controls['StuInHouse'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="reservationsDetailsFormArray['StuMinority'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{reservationsDetailsFormArray['StuMinority'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="reservationsDetailsFormArray['StuMinority'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select [disabled]="isStuMinorityDisable" matTooltip="Do You Belong To Any Minority" formControlName="StuMinority"
                                    #select104 placeholder="Validity" class="colorblack">
                                    <mat-option>Select</mat-option>
                                    <mat-option [value]="1" (click)="StuMinorityTypeDisable(1)">Yes</mat-option>
                                    <mat-option [value]="2" (click)="StuMinorityTypeDisable(2)">No</mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="reservationsDetailsForm.controls['StuMinority'].touched && reservationsDetailsForm.controls['StuMinority'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="reservationsDetailsFormArray['StuMinorityType'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label> {{reservationsDetailsFormArray['StuMinorityType'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="reservationsDetailsFormArray['StuMinorityType'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select formControlName="StuMinorityType" [disabled]="isStuMinorityTypeDisable"
                                    #select104 placeholder="Type" class="colorblack">
                                    <mat-option>Select</mat-option>
                                    <mat-option (click)="fetchMinorityType2(1)" [value]="1">Linguistic</mat-option>
                                    <mat-option (click)="fetchMinorityType2(2)" [value]="2">Religious</mat-option>
                                    <mat-option (click)="fetchMinorityType2(3)" [value]="3">NA</mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="reservationsDetailsForm.controls['StuMinorityType'].touched && reservationsDetailsForm.controls['StuMinorityType'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <!-- noformcontrolname -->
                <div class="col-sm-2" *ngIf="reservationsDetailsFormArray['StuMinorityType2'][0]['FormVisible']">
                    <!--  -->
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{reservationsDetailsFormArray['StuMinorityType2'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="reservationsDetailsFormArray['StuMinorityType2'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select #select23 class="colorblack" formControlName="StuMinorityType2"
                                    [disabled]="isStuMinorityType2Disable">
                                    <mat-select-filter *ngIf="select23.focused" [placeholder]="'Filter'"
                                        [displayMember]="'MinorityName'" [array]="minorityList"
                                        (filteredReturn)="filteredMinorityList =$event">
                                    </mat-select-filter>
                                    <mat-option *ngFor="let item of filteredMinorityList" [value]="item.MinorityId">
                                        {{item.MinorityName}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="reservationsDetailsForm.controls['StuMinorityType2'].touched && reservationsDetailsForm.controls['StuMinorityType2'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="reservationsDetailsFormArray['StuPhyHand'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{reservationsDetailsFormArray['StuPhyHand'][0]['FormDisplayName']}}
                                    <span *ngIf="reservationsDetailsFormArray['StuPhyHand'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select formControlName="StuPhyHand" #select104 placeholder="Specially Abled"
                                    class="colorblack">
                                    <mat-option>Select</mat-option>
                                    <mat-option [value]="1" (click)="StuSpecialAbledTypeDisable('1')">Yes</mat-option>
                                    <mat-option [value]="0" (click)="StuSpecialAbledTypeDisable('0')">No</mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="reservationsDetailsForm.controls['StuPhyHand'].touched && reservationsDetailsForm.controls['StuPhyHand'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-5" *ngIf="reservationsDetailsFormArray['StuSpecialAbledType'][0]['FormVisible']">

                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>
                                  {{ reservationsDetailsFormArray['StuSpecialAbledType'][0]['FormDisplayName'] }}
                                  <span *ngIf="reservationsDetailsFormArray['StuSpecialAbledType'][0]['FormRequired']">*</span>
                                </mat-label>
                              
                                <mat-select
                                  #select24
                                  class="colorblack"
                                  formControlName="StuSpecialAbledType"
                                  [disabled]="isStuSpecialAbledTypeDisable"
                                  [matTooltip]="getSelectedSpecialAbledDesc()"
                                  matTooltipPosition="above"
                                  matTooltipShowDelay="500"
                                >
                                  <mat-select-filter
                                    *ngIf="select24.focused"
                                    [placeholder]="'Filter'"
                                    [displayMember]="'CdDesc'"
                                    [array]="specialAbledList"
                                    (filteredReturn)="filteredspecialAbledList = $event"
                                  ></mat-select-filter>
                              
                                  <mat-option
                                    *ngFor="let item of filteredspecialAbledList"
                                    [value]="item.CdCode"
                                  >
                                    {{ item.CdDesc }}
                                  </mat-option>
                                </mat-select>
                              
                                <mat-error class="margin_tp"
                                  *ngIf="reservationsDetailsForm.controls['StuSpecialAbledType'].touched &&
                                          reservationsDetailsForm.controls['StuSpecialAbledType'].errors?.required">
                                  Mandatory
                                </mat-error>
                              </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="reservationsDetailsFormArray['StuOrphan'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{reservationsDetailsFormArray['StuOrphan'][0]['FormDisplayName']}}
                                    <span *ngIf="reservationsDetailsFormArray['StuOrphan'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select formControlName="StuOrphan" #select104 placeholder="Are You Orphan"
                                    class="colorblack">
                                    <mat-option>Select</mat-option>
                                    <mat-option [value]="1" (click)="StuOrphanTypeDisable('1')">Yes</mat-option>
                                    <mat-option [value]="2" (click)="StuOrphanTypeDisable('2')">No</mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="reservationsDetailsForm.controls['StuOrphan'].touched && reservationsDetailsForm.controls['StuOrphan'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="reservationsDetailsFormArray['StuOrphanType'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{reservationsDetailsFormArray['StuOrphanType'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="reservationsDetailsFormArray['StuOrphanType'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select #select25 class="colorblack" formControlName="StuOrphanType"
                                    [disabled]="isStuOrphanTypeDisable">
                                    <mat-select-filter *ngIf="select25.focused" [placeholder]="'Filter'"
                                        [displayMember]="'CdDesc'" [array]="orphanTypeList"
                                        (filteredReturn)="filteredorphanTypeList =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredorphanTypeList" [value]="item.CdCode">
                                        {{item.CdDesc}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="reservationsDetailsForm.controls['StuOrphanType'].touched && reservationsDetailsForm.controls['StuOrphanType'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="form-group">
                        <mat-label>Social Reservations :</mat-label>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="reservationsDetailsFormArray['StuSocialRes'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{reservationsDetailsFormArray['StuSocialRes'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="reservationsDetailsFormArray['StuSocialRes'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select #select25 class="colorblack" formControlName="StuSocialRes">
                                    <mat-select-filter *ngIf="select25.focused" [placeholder]="'Filter'"
                                        [displayMember]="'CdDesc'" [array]="SRList"
                                        (filteredReturn)="filteredSR =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredSR" [value]="item.CdCode">
                                        {{item.CdDesc}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="reservationsDetailsForm.controls['StuSocialRes'].touched && reservationsDetailsForm.controls['StuSocialRes'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="reservationsDetailsFormArray['BPLCategory'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{reservationsDetailsFormArray['BPLCategory'][0]['FormDisplayName']}}
                                    <span *ngIf="reservationsDetailsFormArray['BPLCategory'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select formControlName="BPLCategory"
                                    placeholder="Whether you belong to BPL Category or not " class="colorblack">
                                    <mat-option>Select</mat-option>
                                    <mat-option [value]="true">Yes</mat-option>
                                    <mat-option [value]="false">No</mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="reservationsDetailsForm.controls['BPLCategory'].touched && reservationsDetailsForm.controls['BPLCategory'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>
 
                        </div>
                    </div>
                </div>
                <div class="row mb-2 prpl">
                    <div class="col-sm-12">
                        <button type="button" *ngIf="submitButton" [disabled]="isSaving"
                            class="btn btn-primary btn-icon-text floatright fr sz mt-1"
                            (click)="markAsTouchedForSub()">
                            <span style="display: contents; align-items: center;">
                                <img width="20%" src="../../assets/images/save.gif" style="margin-right: 5px;">
                                Save
                            </span>
                        </button>
                        <button type="button" *ngIf="updateButton" [disabled]="disabled || isSaving"
                            (click)="markastouched()"
                            class="btn btn-primary btn-icon-text floatright fr sz mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20%" src="../../assets/images/edit.gif" style="margin-right: 5px;">
                                Update
                            </span>
                        </button>
                        <button type="button" (click)="back()" class="btn btn-primary btn-icon-text floatright fr mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20%" src="../../assets/images/turn-left.gif" style="margin-right: 5px;">
                                Back
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- </div> -->
    </div>
</form>